import { observer } from 'mobx-react';
import { SingleValue } from 'react-select';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';
import { IOption, SelectDropdown } from '../../../../../../../components/inputs/select-dropdown/select-dropdown';
import GlobalECredentialsStore from '../../../../stores/credentials/shipping/global-e-credentials-store';
import { GlobalEEnvironment } from '../../../../../../../services/api/admin-migrate-global-e-merchants-service';

const ENVIRONMENT_OPTIONS: IOption[] = Object.entries(GlobalEEnvironment).map(([label, value]) => ({ label, value}));

interface IProps {
    credentialsStore: GlobalECredentialsStore,
    vGroup: IValidationGroup,
}

const GlobalECredentials: React.FC<IProps> = observer(({
                                                         credentialsStore,
                                                         vGroup,
                                                     }) => {
    const handleEnvChange = (option: SingleValue<IOption>) => {
        if (option) {
            credentialsStore.setEnv(option.value as GlobalEEnvironment);
        }
    };

    return (
        <>
            <FormFieldLine
                required
                label='Global-E Base Api Url'
                key='baseApiUrl'
                note='Example: https://connect-qa.bglobale.com'
            >
                <Input
                    value={credentialsStore.baseApiUrl}
                    onChange={credentialsStore.setBaseApiUrl}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Global-E Merchant GUID'
                key='apiUsername'
                note='Your Global-E Merchant GUID'
            >
                <Input
                    value={credentialsStore.apiUsername}
                    onChange={credentialsStore.setApiUsername}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Global-E Environment'
                key='env'
            >
                <SelectDropdown
                    isSearchable={false}
                    value={ENVIRONMENT_OPTIONS.find(o => o.value === credentialsStore.env) ?? null}
                    options={ENVIRONMENT_OPTIONS}
                    onChange={handleEnvChange}
                    placeholder='Select environment'
                    required
                    validationGroup={vGroup}
                />
            </FormFieldLine>
        </>
    );
});

export default GlobalECredentials;
